export enum WallSide {
  north = 0,
  east = 1,
  south = 2,
  west = 3,
  inner = 4,
  ceiling = 5,
  floor = 6,
}
